<template>
    <div class="select-types">
        <p
           class="item"
           :class="{'active': isAll}"
           @click="handleSelectedAll"
        >
            <el-button class="btn" size="mini">全部</el-button>
        </p>
        <p v-for="(item,index) in newForm"
           :key="index"
           class="item"
           :class="{'active': newSelected.includes(item.id)}"
           @click="handleSelected(item)"
        >
            <el-button class="btn" size="mini">{{item.name}}</el-button>
        </p>

    </div>
</template>

<script>
    export default {
        name: "select-types",
        props: {
            form: Array,
            selected: Array
        },
        computed: {
            isAll(){
                let state = false
                if(this.newForm && this.newSelected && this.newSelected.length === this.newForm.length){
                    state = true
                }
                return state
            }
        },
        watch:{
            form(vl){this.newForm = vl},
            newForm(vl){this.$emit('update:form',vl)},
            selected(vl){this.newSelected = vl},
            newSelected(vl){this.$emit('update:selected',vl)},
        },
        data(){
            return {
                newForm: this.form,
                newSelected: this.selected
            }
        },
        methods: {
            handleSelectedAll(){
                if(this.newForm.length !== this.newSelected.length){
                    this.newSelected = this.newForm.map(v=>v.id)
                }else{
                    this.newSelected = []
                }
                this.$emit('onSelectTypes', this.newSelected)
            },
            handleSelected(item){
                if(this.newSelected.includes(item.id)){
                    this.newSelected.splice(this.newSelected.indexOf(item.id), 1)
                }else{
                    this.newSelected.push(item.id)
                }
                this.$emit('onSelectTypes', this.newSelected)
            }
        }
    }
</script>

<style lang="scss" scoped>
.select-types{
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;

    .item{
        display: flex;
        width: 31%;
        justify-content: center;
        margin-bottom: 10px;

        .btn{
            width: 100%;
            border: 1px solid #FFDA07;
            background-color: initial;
            border-radius: 6px;
            color: #666666;
            font-size: 16px;
            overflow: hidden;
            padding-right: 10px;
            padding-left: 10px;
            white-space: nowrap;
            text-overflow: ellipsis;
        }
        &:hover, &.active{
            .btn {
                color: #FFDA07;
                border: 1px solid #FFDA07;
            }
        }
    }
}
</style>